import { CommonModule } from '@angular/common';
import { Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSliderModule } from '@angular/material/slider';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';

interface SliderProps extends FormlyFieldProps {
  thumbLabel?: string;
}

export interface FormlySliderFieldConfig extends FormlyFieldConfig<SliderProps> {
  type: 'slider' | Type<SliderComponent>;
}

@Component({
  selector: 'vectronic-formly-slider',
  imports: [CommonModule, MatSliderModule, MatFormFieldModule, ReactiveFormsModule],
  template: ` <div class="container" [ngClass]="field.className">
    <mat-label>{{ props?.label }}</mat-label>
    <mat-slider [min]="props?.min" [max]="props?.max" [discrete]="props?.thumbLabel">
      <input matSliderThumb [formControl]="formControl" />
    </mat-slider>
  </div>`,
  styles: [
    `
      .container {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-bottom: 1rem;
      }

      mat-slider {
        box-sizing: border-box;
        margin: 1.5rem 1.5rem 0;
      }

      .form-field--admin {
        border: solid 2px red;
        padding: 0.25rem 1rem;

        mat-slider {
          margin: 1.5rem 0.5rem 0;
        }
      }
    `,
  ],
})
export class SliderComponent extends FieldType<FieldTypeConfig<SliderProps>> {}
